import { render, staticRenderFns } from "./org-btn.vue?vue&type=template&id=7d38ce31&scoped=true&"
import script from "./org-btn.vue?vue&type=script&lang=js&"
export * from "./org-btn.vue?vue&type=script&lang=js&"
import style0 from "./org-btn.vue?vue&type=style&index=0&id=7d38ce31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d38ce31",
  null
  
)

export default component.exports